// extracted by mini-css-extract-plugin
export var closeButton = "_5s-0";